// removed by extract-text-webpack-plugin
module.exports = {"Steps":"Steps","StepItem":"StepItem","StepIndex":"StepIndex","active":"active","complete":"complete","icon-ok":"icon-ok"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Steps/Steps.scss
// module id = AQeU
// module chunks = 0